import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import GetInspirationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/InspirationSerivce/GetInspirationResponse";
import InspirationUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/InspirationSerivce/InspirationUpdateRequest";
import { mapToCropRequest } from "@/frameworks/imagePreviewModelMapper";
import InspirationTranslateModel from "./inspirationTranslateModel";

export default class CreateInspirationViewModel {
    id?: number = null;
	date: Date = null;
	backgroundImage: ImagePreviewModel = new ImagePreviewModel();
	translations: Array<InspirationTranslateModel> = null;
    initLanguages(langs: string[]) {
        this.translations = (langs || []).map(x => new InspirationTranslateModel({
            langCode: x
        }));
    }
	toServerModel(): InspirationUpdateRequest {
		const req = new InspirationUpdateRequest({
			Id: this.id,
			Back: mapToCropRequest(this.backgroundImage),
			Translations: this.translations.map(x=>x.toServerModel())
		});
		
		return req;
	}
	fromServerModel(model: GetInspirationResponse) {
		this.id = model.Id;
		this.date = model.Date;
		this.backgroundImage.ImageUrl = model.BackUrl;
		this.translations.forEach(tr => {
			const serverTranslation = model.Transations.find(x=>x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.text = serverTranslation.Text;
			}
		});
	}
}